'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base class for experiment evaluation and logging
 *
 * @abstract
 */
var BaseExperimentEvaluator = function () {
    /**
     * Uses {@link BucketConfig} to configure the experiment evaluator and initializes `exposedExperiments` which is used to
     * keep track of experiments that have been exposed
     *
     * @constructor
     * @param {BucketConfig} bucketConfig - configuration for the evaluator
     */
    function BaseExperimentEvaluator(bucketConfig) {
        _classCallCheck(this, BaseExperimentEvaluator);

        if (this.constructor === BaseExperimentEvaluator) {
            throw new Error('Cannot instantiate a BaseExperimentEvalutor. Please extend and implement.');
        }
        this.bucketConfig = bucketConfig;
        this.exposedExperiments = {}; // Keep track of exposed experiments to avoid sending extra unneeded EDAP events
    }

    /**
     * Returns an instance of EvaluationData for the specified experiment id. This function does not log the
     * evaluation. Please ensure you understand how to separate evaluation from logging before using this function. Always
     * prefer to use {@link evaluateExperimentAndLog|evaluateExperimentAndLog()}.
     *
     * @abstract
     * @param {number} experimentId - the id of the experiment to evaluate
     * @returns {EvaluationData}
     */
    // eslint-disable-next-line no-unused-vars


    _createClass(BaseExperimentEvaluator, [{
        key: 'evaluateExperiment',
        value: function evaluateExperiment(experimentId) {
            throw new Error('Not implemented');
        }

        /**
         * Returns an instance of EvaluationData for all experiments running on the page. This function does not log the
         * evaluation. To evaluate specified experiment id without logging use {@link evaluateExperiment|evaluateExperiment()}.
         *
         * @abstract
         * @returns {EvaluationData}
         */

    }, {
        key: 'evaluateAllExperiments',
        value: function evaluateAllExperiments() {
            throw new Error('Not implemented');
        }

        /**
         * Retrieves an already evaluated experiment, logs the exposure of an experiment, and returns the result as an EvaluationData object. If any
         * errors occur than the resulting EvaluationData will contain details of the error and the EGTnlBucket bucket value will
         * refer to the control bucket.
         *
         * @abstract
         * @param {number} experimentId - the id of the experiment to evaluate
         * @param {object} [loggerParams] - parameters passed to the specific loggers that are configured
         * @returns {EvaluationData}
         */
        // eslint-disable-next-line no-unused-vars

    }, {
        key: 'evaluateExperimentAndLog',
        value: function evaluateExperimentAndLog(experimentId, loggerParams) {
            throw new Error('Not implemented');
        }

        /**
         * Logs an already evaluated experiment. Keeps track of which experiments have been logged using `exposedExperiments` so that
         * the exposure event is triggered at most once per test per pageload.
         *
         * Please ensure you understand how to separate evaluation from logging before using this function. Your experiment will
         * be invalid if the passed in EvaluationData has not come as a result of calling evaluateExperiment().
         *
         * @abstract
         * @param {EvaluationData|number} evaluationData - Object that contains information about the evaluated test. Alternatively, supply an experiment id.
         * @param {object} [loggerParams] - parameters passed to the specific loggers that are configured
         */
        // eslint-disable-next-line complexity
        // eslint-disable-next-line no-unused-vars

    }, {
        key: 'logExperiment',
        value: function logExperiment(evaluationData, loggerParams) {
            throw new Error('Not implemented');
        }

        /**
         * Returns the EvaluateData for experiments that are configured in the experiment evaluator
         *
         * @protected
         * @returns {Object.<number, EvaluationData>}
         */

    }, {
        key: 'getEvaluatedExperiments',
        value: function getEvaluatedExperiments() {
            return this.bucketConfig.evaluatedExperiments;
        }

        /**
         * Returns the configured exposure loggers to be used for exposure logging
         *
         * @protected
         * @returns {ExposureLogger[]}
         */

    }, {
        key: 'getExposureLoggers',
        value: function getExposureLoggers() {
            return this.bucketConfig.exposureLoggers;
        }
    }]);

    return BaseExperimentEvaluator;
}();

exports.default = BaseExperimentEvaluator;
//# sourceMappingURL=BaseExperimentEvaluator.js.map